





















































































import {Vue, Component, Ref, Watch, PropSync} from 'vue-property-decorator';
import {Action, Getter} from "vuex-class";
import {SelectWings} from "wings-ui-components";
import { CollapseTransition } from "vue2-transitions";
import {notifyError, notifySuccess} from "@/utils/notify-helper";
import {readFileAsBinary, readFileAsText} from "@/utils/download-helper"
import {BlacklistImportRequest, BlacklistItem} from "@/store/blacklists/types";
import { getTranslatedParams } from '@/utils/notify-utils';
import { ActionLog } from '@/store/auth/types';

@Component({components: {CollapseTransition,SelectWings}})
export default class ImportContacts extends Vue {
  @Ref('validator') validator: any;
  @PropSync('show') is_show!: boolean;
  @PropSync('blacklist_id') blacklistId!: number;
  @Getter delimiterList:any;
  @Getter("blacklistItem") blacklistItem: any;
  @Action("importBlackListContacts") actionImport: any;
  @Action("preImport") actionPreImport: any;
  @Action("getBlackListItem") actionGetItem: any;
  @Action("actionLog") actionLog: any;

  logObject: ActionLog = {}

  defaultImportRequest(): BlacklistImportRequest {
    return new BlacklistImportRequest(this.blacklistId)
  }

  importRequest = this.defaultImportRequest()
  file: any = null
  fieldTypes = this.defaultFieldTypes()
  fields = []
  autoImport = true
  isTextFile = false
  groupItem: BlacklistItem = {}

  defaultFieldTypes() {
    return ['MSISDN', 'EMAIL','COMMENT']
  }

  get fieldTypeNames() {
    return this.fieldTypes.map((item:any) => this.$t('contacts.types.'+item))
  }

  async created() {
    if (this.$route.params.id) {
      try {
        this.groupItem = await this.actionGetItem(this.$route.params.id)
      } catch (error) {
        notifyError(error);
      }
    }
  }

  get showCheckDuplicates() {
    // return true
    return 'checkDuplicatesPolicy' in this.groupItem && this.groupItem.checkDuplicatesPolicy != 0
  }

  @Watch('autoImport')
  onAutoImportChanged(val: boolean) {
    if (!val) this.readFile()
  }

  @Watch('importRequest.separator')
  onSeparatorChanged(val: boolean) {
    this.readFile()
  }

  onFileUpload (evt:any) {
    this.file = evt[0]
    this.readFile()
  }

  async readFile() {
    if (this.autoImport) return
    if (!await this.validator.validate()) return
    try {
      this.isTextFile = false
      if (["text/csv", "text/plain"].includes(this.file.type)) {
        this.isTextFile = true
        const fileData = await readFileAsText(this.file)
        const firstrow = fileData.split('\n').shift()
        this.fields = firstrow.split(this.importRequest.separator)
      }
      else
      {
        this.fields = await this.actionPreImport({
          separator: this.importRequest.separator,
          fileName: this.importRequest.fileName,
          file: btoa(await readFileAsBinary(this.file))
        })
      }
      this.importRequest.fieldSequence = this.fields.map(() => '')

    } catch (error) {
      console.log(error)
      notifyError(error);
    }
  }

  async importFile():Promise<void> {
    if (!await this.validator.validate()) {
      notifyError(null, this.validator.errors)
      return
    }
    if (!this.autoImport) {
      const isFilled = this.importRequest.fieldSequence.find((item:string) => item == 'MSISDN' || item == 'EMAIL')
      if (!isFilled) {
        notifyError(null, null, this.$t('contacts.messages.requiredMissing').toString())
        return
      }
      const fieldSequenceFiltered = this.importRequest.fieldSequence.filter((item:string) => item != '')
      const isDuplicates = new Set(fieldSequenceFiltered).size !== fieldSequenceFiltered.length
      if (isDuplicates) {
        notifyError(null, null, this.$t('contacts.messages.fieldTypeDuplicates').toString())
        return
      }
    }
    try {
      this.importRequest.blackListId = this.blacklistId
      this.importRequest.file = btoa(await readFileAsBinary(this.file))
      if (this.autoImport) this.importRequest.fieldSequence = this.defaultFieldTypes()

      this.logObject = {
        actionPage: this.$route.meta.msgKey,
        action: "Import",
        actionStatus: 'success',
        objectType: "Contact",
        addititionalInfo: getTranslatedParams({file: this.importRequest.fileName, contactsImported: undefined, blackListId: this.blacklistItem?.name})
      }

      const data = await this.actionImport(this.importRequest);
      const msg = [this.$t('contacts.messages.importCount').toString() + data?.contactsCount]
      if (data?.msisdnDuplicateCount) msg.push(this.$t('contacts.messages.msisdnDuplicates').toString() + data?.msisdnDuplicateCount)
      if (data?.msisdnDuplicates?.length) msg.push(data?.msisdnDuplicates.join(', '))
      if (data?.failedMsisdnCount) msg.push(this.$t('contacts.messages.failedMsisdns').toString() + data?.failedMsisdnCount)
      if (data?.failedMsisdns?.length) msg.push(data?.failedMsisdns.join(', '))
      if (data?.emailDuplicateCount) msg.push(this.$t('contacts.messages.emailDuplicates').toString() + data?.emailDuplicateCount)
      if (data?.emailDuplicates?.length) msg.push(data?.emailDuplicates.join(', '))
      if (data?.failedEmailCount) msg.push(this.$t('contacts.messages.failedEmails').toString() + data?.failedEmailCount)
      if (data?.failedEmails?.length) msg.push(data?.failedEmails.join(', '))

      notifySuccess(msg.join('<br>'));

      this.logObject.addititionalInfo.contactsImported = data?.contactsCount;
      await this.actionLog(this.logObject)

      this.$emit('refresh')
      this.importRequest = this.defaultImportRequest()

    } catch (error) {
      notifyError(error);
      await this.actionLog({...this.logObject, actionStatus: 'failed'})
    }
  }
}
